exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-gradient-primary[data-v-2ae21c91]{background-image:linear-gradient(#ed1a3a,#7f091b 100%)!important}.btnRegister[data-v-2ae21c91]{background:#ca1732!important}.btnRegister[data-v-2ae21c91]:hover{background:#7f091b!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/buzius/projects/easyflow-docker/workspace/easyflow/node_modules/css-loader?minimize!/home/buzius/projects/easyflow-docker/workspace/easyflow/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2ae21c91","scoped":true,"hasInlineConfig":false}!/home/buzius/projects/easyflow-docker/workspace/easyflow/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Registration.vue
// module id = 136
// module chunks = 0